// One source of truth for API base URL.
// Priority:
// 1) REACT_APP_API_BASE_URL at build time
// 2) Derive from window.location: https://api.<full-host>/api
// 3) Local dev: http://localhost:3015/api

const RAW = (typeof process !== 'undefined' && process.env) || {};
const fromEnv = (RAW.REACT_APP_API_BASE_URL || '').replace(/\/+$/, '');

function deriveFromHost() {
  if (typeof window === 'undefined') return '';
  const host = window.location?.hostname || '';

  // Local dev
  if (/^(localhost|127\.0\.0\.1)$/.test(host)) return 'http://localhost:3015/api';
  if (!host) return '';

  // PREPEND "api." to the full host (do NOT replace a label)
  // shimbirr.taban.so -> api.shimbirr.taban.so
  // app.example.com    -> api.app.example.com
  return `https://api.${host}/api`;
}

const API_BASE_URL = (fromEnv || deriveFromHost()).replace(/\/+$/, '');
const FILES_BASE_URL = API_BASE_URL ? API_BASE_URL.replace(/\/api$/, '') : '';

if (!API_BASE_URL && typeof window !== 'undefined') {
  // eslint-disable-next-line no-console
  console.error('[apiBase] Missing API base URL. Set REACT_APP_API_BASE_URL in .env.development/.env.production.');
}

export { API_BASE_URL, FILES_BASE_URL };
export default API_BASE_URL;
